import dayjs from 'dayjs';
import forOwn from 'lodash/forOwn';
import Vue from 'vue';

const filters = {
	momentFormat (value, outFormat, inFormat) {
		const m = dayjs(value, inFormat);
		if (m.isValid()) {
			return m.format(outFormat);
		}
		return value;
	},

	formatTime (value, outFormat, inFormat) {
		const m = dayjs(value, inFormat || 'HH:mm:ss');
		if (m.isValid()) {
			return m.format(outFormat || 'H:mm');
		}
		return '';
	},

	round (value) {
		return Math.round(value);
	},

	currency (val) {
		const str = Number(val).toFixed(2);
		const arr = str.split('.');
		const decimal = arr[1];
		let negative = false;
		
		if (arr[0].startsWith('-')) {
			negative = true;
			arr[0] = arr[0].substring(1);
		}
		
		const integer = arr[0].split('').reverse().join('').match(/.{1,3}/g).join(' ').split('').reverse().join('');
		return `${negative ? '-' : ''}${integer},${decimal} zł`;
	},

	absolute (val) {
		return Math.abs(val);
	},
	
	hoursToTime (value) {
		const hours = String(Math.floor(+value));
		const minutes = String(Math.round((value - hours) * 60)).padStart(2, '0');
		return `${hours}:${minutes}`;
	},
	
	intToTime (value) {
		const hours = Math.floor(value / 60);
		const minutes = String(value % 60).padStart(2, '0');
		return `${hours}:${minutes}`;
	},
	
	sumArrayField (array, field) {
		return array.reduce((sum, row) => sum + (Number(row[field]) || 0), 0);
	}
};

filters.dayjsFormat = filters.momentFormat;

const registerAllFilters = () => {
	forOwn(filters, (filter, name) => {
		Vue.filter(name, filter);
	});
};

export {
	registerAllFilters,
	filters
};
